/**
 * Case-insensitive substring match for Audit Logs filters.
 * @param {*} value row value
 * @param {*} query expected text
 * @return {boolean} whether the row matches
 */
export function containsIgnoreCase(value, query) {
	return String(value ?? '').toLocaleLowerCase().includes(
		String(query ?? '').toLocaleLowerCase(),
	);
}

/**
 * Put login wording in the form the Audit Logs search API matches.
 * @param {*} query spoken or typed search text
 * @return {string} search box text
 */
export function normalizeAuditLogSearchQuery(query) {
	return String(query || '')
		.replace(/(logged)\s*(in|out)/gi, '$1 $2')
		.replace(/\s+/g, ' ')
		.trim();
}

/**
 * Unique Modified Module names, keeping first-seen spelling.
 * @param {Array} rows audit log or content-type rows
 * @return {string[]} unique module labels
 */
export function uniqueModifiedModules(rows) {
	const seen = new Set();
	const modules = [];
	(Array.isArray(rows) ? rows : []).forEach((row) => {
		const name = String(row?.model || '').trim();
		const folded = name.toLocaleLowerCase();
		if (!name || seen.has(folded)) return;
		seen.add(folded);
		modules.push(name);
	});
	return modules;
}

const ACTION_API = {
	create: '0',
	update: '1',
	delete: '2',
	'0': '0',
	'1': '1',
	'2': '2',
};

/**
 * Map an Action label to the Audit Logs filter encoding.
 * @param {*} value supplied action
 * @return {string|null} Canvas action id
 */
export function actionApiValue(value) {
	const key = String(value || '').trim().toLocaleLowerCase();
	return ACTION_API[key] || null;
}

/**
 * Whether a row can open View More Log Details.
 * @param {object} row audit log row
 * @return {boolean} whether Log Details is available
 */
export function auditLogSupportsViewMore(row) {
	if (!row) return false;
	const action = Number(row.action);
	const model = String(row.model || '');
	return action === 1 ||
		(action === 2 && model === 'Tenant') ||
		model === 'license device';
}

/**
 * Split an agent filter event into search and Audit Logs Filter fields.
 * @param {object} detail filter event detail
 * @return {{query: string, username: string, module: string, action: string, fromDate: string, toDate: string, download: boolean}} split filter
 */
export function auditLogFilterFromDetail(detail = {}) {
	const query = String(detail.query || '').trim();
	const action = actionApiValue(detail.action);
	return {
		query,
		username: String(detail.username || '').trim(),
		module: String(detail.module || '').trim(),
		action: action || '',
		fromDate: String(detail.from_date || '').trim(),
		toDate: String(detail.to_date || '').trim(),
		download: String(detail.download_format || '').trim().toLocaleLowerCase() ===
			'csv' ||
			String(detail.action_target || '').trim() === 'download',
		clear: detail.clear === true || String(detail.clear || '') === 'true',
	};
}
